
import {
    Container,
    Graphics,
    Rectangle
} from 'pixi.js';
import { LoadContext, DisposableGroup } from '../../utils';
import { Game } from '../../game';
import { Settings } from '../../settings';
import { RestAreaSwitch } from './RestAreaSwitch';
import { Focusable, UILabel, InteractiveWrapper } from '../../ui';

export class DwellRestArea extends Container {

    public label:UILabel;
    protected game:Game;
    protected settings:Settings;
    protected icon_x:number = 40;
    protected icon_y:number = 20;
    protected title_vo:string;
    protected explain_vo:string;
    protected settings_vo:string;
    protected disposables: DisposableGroup;
    public switch: RestAreaSwitch;

    public static preload() {
        LoadContext.current.add('TitleAtlas', './assets/title/TitleAtlas{size}.json');
        RestAreaSwitch.preload(true);
        UILabel.preload();
    }

    constructor( game: Game)
    {
        super();
        this.disposables = new DisposableGroup();
        this.game = game;

        const title = 'Switch Access';
        const vo = {
            title: "CYB_Panel_Dwell",
            explain: 'CYB_Panel_DwellSettings',
            settings: 'CYB_Panel3_DwellSelected',
        }
        this.settings = this.game.settings;
        this.title_vo = vo.title;
        this.explain_vo = vo?.explain;
        this.settings_vo = vo.settings;

        const loader = LoadContext.current;

        if (title)
        {
            this.label = new UILabel(
                title,
                {
                    align: 'center',
                    fontName: 'AsapMedium',
                    fontSize: 25,
                    tint: 0xffffff
                },
                loader.getTexture('icon_question_title', 'TitleAtlas')
            );
            this.disposables.add(new InteractiveWrapper(this.label, {
                onHover: async () => {
                    await this.game.vo.playVO( [this.title_vo, this.settings_vo] );
                },
                onTap: async () => {
                    this.game.vo.stop();
                    await this.game.vo.playVO( this.explain_vo );
                },
                onActivate: async () => {
                    this.game.vo.stop();
                    await this.game.vo.playVO( this.explain_vo );
                    await this.game.vo.playVO(this.settings_vo);
                }
            }));
            this.label.position.set( 20, 0 );
            this.addChild( this.label );
        }

        this.switch = new RestAreaSwitch(true);
        this.switch.position.set( 200, 0 );
        this.game.settings.enableDwellClicks.value = false; // disable so character doesn't automove at start of level
        this.updateToMatchSetting();

        this.switch.on( "switchChanged", (newValue:boolean)=>{
            this.game.vo.stop();
            this.game.settings.enableDwellClicks.value = newValue;
            const eventName: string = newValue ? "dwell_activation_on" : "dwell_activation_off";
            this.game.logEvent("change_setting", eventName);
            this.playSwitchVO( this.switch );
        });
        this.disposables.add(new InteractiveWrapper(this.switch, {
            onHover: () => {
                this.playSwitchHover( this.switch );
            },
            onTap: () => {},
            forceDwell: true
        }));
        this.addChild( this.switch );
    }

    public get shouldPlayAD()
    {
        return this.settings.playAudioDescriptions.value;
    }

    public getFocusItems():Focusable[]
    {
        let ret:Focusable[] = this.label ? [ this.label ] : [];
        return ret.concat( [this.switch] );
    }

    protected getSize()
    {
        const target = this.switch;
        return {width: target.width, height: target.height};
    }

    updateToMatchSetting()
    {
        this.switch.isOn = this.game.settings.enableDwellClicks.value;
    }

    protected playSwitchHover( theSwitch:RestAreaSwitch ) : Promise<void>
    {
        let ret:Promise<void>;
        if( theSwitch.isOn ) {
            ret = this.game.vo.playHighlight( [this.title_vo, 'CYB_Panel1_On'], false );
        } else {
            ret = this.game.vo.playHighlight( [this.title_vo, 'CYB_Panel1_Off'], false );
        }
        return ret;
    }

    protected playSwitchVO( theSwitch:RestAreaSwitch ) : Promise<void>
    {
        let ret:Promise<void>;
        if( theSwitch.isOn ) {
            ret = this.game.vo.playHighlight( [this.title_vo, 'CYB_Panel1_On'], false );
        } else {
            ret = this.game.vo.playHighlight( [this.title_vo, 'CYB_Panel1_Off'], false );
        }
        return ret;
    }


    public set enabled(enabled: boolean)
    {
        this.switch.enabled = enabled;
        this.label.enabled = enabled;
    }


    destroy()
    {
        this.disposables.dispose();
        super.destroy({children: true});
    }
}